// extracted by mini-css-extract-plugin
module.exports = {"card":"Indicator_card__3qTPM","cardHeading":"Indicator_cardHeading__Ssy3H","cardTitle":"Indicator_cardTitle__3xDfa","cardBody":"Indicator_cardBody__3Xzoe"};